const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})/
const EMAIL_REGEX =
  /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
const NAME_REGEX = /^[a-zA-z]+([\s][a-zA-Z]+)*$/

const MESSAGES = {
  full_name: { required: "Full Name is required", invalid: "Full Name is invalid" },
  email: { required: "Email is required", invalid: "Email is invalid" },
  password: {
    required: "Password is required",
    invalid:
      "Password is invalid. It is require at least 8 characters, mixture of both uppercase and lowercase letters, inclusion of at least one special character & 1 or more number.",
  },
  password_confirmation: {
    required: "Confirm Password is required",
    invalid: "Password is not matched",
  },
}

export function messageFor(field, input, passwordValue, confirmValue) {
  const value = input.value

  switch (field) {
    case "full_name":
      if (!value.trim()) return MESSAGES.full_name.required
      if (!NAME_REGEX.test(value)) return MESSAGES.full_name.invalid
      return ""
    case "email":
      if (!value.trim()) return MESSAGES.email.required
      if (!EMAIL_REGEX.test(value.toLowerCase())) return MESSAGES.email.invalid
      return ""
    case "password":
      if (!value) return MESSAGES.password.required
      if (!PASSWORD_REGEX.test(value)) return MESSAGES.password.invalid
      return ""
    case "password_confirmation":
      if (!value) return MESSAGES.password_confirmation.required
      if (value !== passwordValue || !passwordValue)
        return MESSAGES.password_confirmation.invalid
      return ""
    default:
      return ""
  }
}
